export default __webpack_public_path__ + "static/media/sinexito.8985681b.png";